import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import CheckInTool from '../components/CheckInTool';
import CheckInToolMobile from '../components/CheckInToolMobile';
import styles from './SecondaryCheckInModal.module.scss';

interface SecondaryCheckInModalProps {
  studentName: string;
  onEmotionSelect: (emotion: string) => void;
  onClose: () => void;
  isSubmitting: boolean;
}

const SecondaryCheckInModal: React.FC<SecondaryCheckInModalProps> = ({
  studentName,
  onEmotionSelect,
  onClose,
  isSubmitting,
}) => {
  const [selectedEmotion, setSelectedEmotion] = useState<string>('');
  const isSmall = useMediaQuery({ query: '(max-width: 820px)' });

  const handleEmotionClick = (emotion: string) => {
    if (!isSubmitting) {
      setSelectedEmotion(emotion);
      // Only trigger the save if a valid emotion was selected (not empty)
      if (emotion && emotion.trim() !== '') {
        onEmotionSelect(emotion);
      }
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={isSmall ? styles.modalContentMobile : styles.modalContentDesktop}>
        {/* Header */}
        <div className={styles.modalHeader}>
          <div className={styles.headerText}>
            <h2>How are you feeling right now?</h2>
            <p>Hi {studentName}, select an emotion from the wheel to check in</p>
          </div>
          <button onClick={onClose} disabled={isSubmitting} className={styles.closeButton}>
            <svg fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
            </svg>
          </button>
        </div>

        {/* Emotion Wheel */}
        <div className={styles.wheelContainer}>
          {isSmall ? (
            <CheckInToolMobile handleEmotionClick={handleEmotionClick} selectedEmotion={selectedEmotion} />
          ) : (
            <CheckInTool handleEmotionClick={handleEmotionClick} selectedEmotion={selectedEmotion} />
          )}
        </div>

        {/* Footer instruction */}
        <div className={styles.footer}>
          <p>
            {isSmall
              ? 'First tap an inner category, then select a specific emotion from the outer ring'
              : 'Click on any emotion in the outer ring to check in'}
          </p>
        </div>

        {/* Loading overlay */}
        {isSubmitting && (
          <div className={styles.submittingOverlay}>
            <div className={styles.submittingContent}>
              <div className={styles.spinner}></div>
              <p>Saving check-in...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SecondaryCheckInModal;
